import {
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { OPTIONS_YES_NO } from "@app/pages/samples/components/analysisComponents/iodo131/utils/constants";
import { useFormContext } from "react-hook-form";

const EquiposForm = () => {
  // const { watch } = useFormContext();
  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MTextField
          key={"codigo"}
          name={"codigo"}
          label={"Código"}
          type="text"
          fullWidth
          validation={{ required: `El campo código es requerido` }}
        />

        <MTextField
          key={"descripcion"}
          name={"descripcion"}
          label={"Descripción"}
          type="text"
          fullWidth
          validation={{ required: `El campo descripción es requerido` }}
        />
        <MTextField
          key={"codet"}
          name={"codet"}
          label={"Código viejo"}
          type="text"
          fullWidth
        />
        <MTextField
          key={"codigoviejo"}
          name={"codigoviejo"}
          label={"Detector"}
          type="text"
          fullWidth
        />
        <MTextField
          key={"mide"}
          name={"mide"}
          label={"mide"}
          type="text"
          fullWidth
        />
        <MTextField
          key={"height"}
          name={"height"}
          label={"Altura"}
          type="text"
          fullWidth
          // validation={{
          //   required:
          //     watch("is_geometry")?.value === 1
          //       ? "El campo altura es requerido"
          //       : false,
          // }}
        />
        <MTextField
          key={"factor"}
          name={"factor"}
          label={"Factor"}
          type="text"
          fullWidth
        />
        <MAutocomplete
          name="is_geometry"
          options={OPTIONS_YES_NO}
          label="Es geometría"
          getOptionLabel={(option) => `${option.label}`}
          validation={{ required: `El campo geometría es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default EquiposForm;
